import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/digithia-logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-373587c3")

_pushScopeId("data-v-373587c3")
const _hoisted_1 = { class: "reset-password" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  slot: "logo",
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_3 = {
  slot: "title",
  class: "center title-2"
}
const _hoisted_4 = {
  slot: "form",
  class: "reset-password-form"
}
const _hoisted_5 = { class: "submit" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("dig-ui-login-card", _hoisted_1, [
    _hoisted_2,
    _createVNode("dig-ui-title", _hoisted_3, _toDisplayString(_ctx.$t('chooseNewPassword')), 1),
    _createVNode("div", _hoisted_4, [
      _createVNode("dig-input-text", {
        value: $setup.password,
        onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.password = $event.target.value)),
        onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.keydownReset && $setup.keydownReset(...args))),
        required: "",
        id: "password",
        type: "password"
      }, _toDisplayString(_ctx.$t('password')), 41, ["value"]),
      _createVNode("div", _hoisted_5, [
        _createVNode("dig-ui-standard-button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.resetPassword()))
        }, _toDisplayString(_ctx.$t('validate')), 1)
      ])
    ])
  ]))
})